import { RX } from './constants';

module.exports = (flex = window.flex) => {

    const trackLogin = ({ session }) => {
        flex.trigger(RX.TRACK.SESSION_LOGGED_IN, { session });
    };

    flex.onTrigger(RX.GLOBAL.SESSION_LOGGED_IN, trackLogin);
}